import * as React from 'react';
import { FeatureFlagsPreviewState, useFeatureFlagsPreview } from './useFeatureFlagsPreview';
import { featureFlagsPreviewKeyOf } from '../models/FeatureFlagsPlanning';

export const FeatureFlagsPreview = <Args extends unknown[], T>({
    args,
    planning,
    refresh,
    onPreview
}: {
    args: Args;
    planning: (...previewArgs: Args) => Promise<T>;
    refresh: number;
    onPreview: React.Dispatch<React.SetStateAction<FeatureFlagsPreviewState<T>>>;
}) => {
    const requestKey = featureFlagsPreviewKeyOf(planning, args);
    const request = React.useRef({ key: requestKey, args });
    // Equivalent form renders allocate fresh arrays; only a semantic change replaces the captured arguments.
    if (request.current.key !== requestKey) {
        request.current = { key: requestKey, args };
    }
    const stableArgs = request.current.args;
    const load = React.useCallback(() => planning(...stableArgs), [planning, stableArgs]);
    useFeatureFlagsPreview(requestKey, refresh, load, onPreview);
    // Ant Design 4.16 Form.Item render callbacks cannot host hooks, so this component renders no DOM.
    return null;
};
